import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const CardContainer = styled.div`
	overflow: hidden;
	position: relative;
	width: 100%;
	margin: 0;
	left: 0;
	transition: all 0.4s;
	text-align: left;

	.card__data {
		background: #fff;
		bottom: 0;
		color: #fff;
		height: 100%;
		left: 200px;
		opacity: 0;
		position: absolute;
		transform: translateX(100%);
		transition: transform 0.4s, opacity 0.1s 0.3s;
		width: 100%;
	}

	&:hover {
		position: relative;
		left: -223px;
		width: 226%;
		opacity: 1;
		transform: translateX(0);

		.card__data {
			opacity: 1;
			transform: translateX(0);
			transition: transform 0.4s, opacity 0.1s;
		}
	}
	img {
		bottom: 0;
		display: block;
		/* height: auto; */
		height: 315px;
		max-width: 100%;
	}

	.card__hover {
		background: #fff;
		width: 230px;
		padding: 15px;
	}

	.card__description {
		font-size: 13px;
		color: #515151;
		width: 90%;
		line-height: 18px;
	}

	.socialnetwork {
		bottom: 16px;
		position: absolute;
		img {
			width: 25px;
			height: 25px;
		}
	}

	.button__arrow-rigth {
		padding: 5px;
		color: ${props => props.theme.label.color};
		background-color: #ffffff;
		bottom: 10px;
		right: 10px;

		${props => props.theme.breakpoints.up('xs')} {
			position: absolute;
		}

		${props => props.theme.breakpoints.up('md')} {
			display: none;
		}
	}
`;

export default CardContainer;

export const StyledTypography = styled(Typography)`
	&& {
		color: #002b5c;
		font-weight: 300;
		padding: 0px;
		font-size: 18px;
		line-height: unset;
		${props => props.theme.breakpoints.down('sm')} {
			font-size: 15px;
		}
	}
`;
